// extracted by mini-css-extract-plugin
module.exports = {"switcher":"_switcher_switcher__IgEXp","switcherContainer":"_switcher_switcherContainer__YLMbs","label":"_switcher_label___w2m3"};